import { APIModel } from '@shared/interfaces';

import { Language } from './language.enum';

import { environment } from '@env';
import { getLocalizedCsamApplication } from './localized-csam-application';

export class Company implements APIModel {
    id = -1;
    firmId = -1;
    sfFirmId = -1;
    name = '';
    companyType = '';
    vat = '';
    silverfinUrl = '';
    personalTaxReconciliationId = -1;
    sfCompanyId = -1;
    language: Language = Language.NL;
    email?: string;
    socialSecurityNumber?: string;
    accountancySynchronisationEntityType = '';
    administrationSynchronisationEntityType = '';
    syncReference = '';
    following = false;
    fileCode = '';
    csamMandates : string[] = [];
    localizedCsamMandates: string[] = [];

    deserialize(data: any): this {
        this.id = data.id ?? -1;
        this.sfFirmId = data.firm?.firm_id ?? -1;
        this.firmId = data.firm?.id ?? -1;
        this.name = data.name ?? '';
        this.companyType = data.company_type ?? '';
        this.vat = data.vat ?? '';
        this.sfCompanyId = data.company_id ?? -1;
        this.silverfinUrl = environment.silverfinCompanyLink(this.sfFirmId, this.sfCompanyId);
        this.personalTaxReconciliationId = data.personal_tax_reconciliation_id ?? -1;
        this.language = data.language ?? Language.NL;
        this.email = data.email ?? '';
        this.socialSecurityNumber = data.social_security_number?.replace(/[^0-9]/g, '') ?? '';
        this.accountancySynchronisationEntityType = data.accountancy_synchronisation_entity_type ?? '';
        this.administrationSynchronisationEntityType = data.administration_synchronisation_entity_type ?? '';
        this.syncReference = data.sync_reference ?? '';
        this.following = data.following ?? false;
        this.fileCode = data.file_code ?? '';
        this.csamMandates = data.csam_mandates ?? [];
        this.localizedCsamMandates = this.csamMandates.map((key) => getLocalizedCsamApplication()[key] ?? key);
        return this;
    }

    serialize(): any {
        return {
            id: this.id,
            firm_id: this.firmId,
            name: this.name,
            companyType: this.companyType,
            vat: this.vat,
            personal_tax_reconciliation_id: this.personalTaxReconciliationId,
            company_id: this.sfCompanyId,
            language: this.language,
            email: this.email,
            social_security_number: this.socialSecurityNumber?.replace(/[^0-9]/g, ''),
            following: this.following,
            file_code: this.fileCode,
        };
    }

    copy(): Company {
        let data = this.serialize();
        data.firm = {
            id: this.firmId,
            firm_id: this.sfFirmId,
        };
        return new Company().deserialize(data);
    }
}
